module.exports = __webpack_public_path__ + "static/img/homepages.aa1b8e25.png";